import {
  ACTIVATE_GREEN_LIGHT,
  ACTIVATE_CARD_LIGHT,
  DEACTIVATE_GREEN_LIGHT,
  DEACTIVATE_CARD_LIGHT,
  SET_CURRENT_ZONE,
  SET_TICKET_ZONES,
  SET_TICKET_PASSENGERS,
  SET_SEASONAL_TICKET_ZONES,
  RESET,
} from './actions';

export const initialState = {
  greenLightActive: false,
  cardLightActive: false,
  currentZone: 'B',
  valueTicket: {
    zones: null,
    passengers: 1,
  },
  extraTicket: {
    seasonalTicketZones: 'AB',
    zones: null,
    passengers: 1,
  },
  seasonalTicket: {
    zones: null,
  },
  additionalZoneTicket: {
    seasonalTicketZones: 'AB',
    zones: null,
    passengers: 1,
  },
  remainingFunds: 21.2,
};

export const getSeasonalTicketZonesByCurrentZone = (currentZone) => {
  switch (currentZone) {
    case 'B':
      return 'AB';
    case 'C':
      return 'BC';
    case 'D':
      return 'CD';
    case 'A':
    default:
      return 'AB';
  }
};

const setCurrentZone = (state, currentZone) => ({ ...state, currentZone });

const setTicketZones = (state, payload) => {
  const { ticketType, zones } = payload;
  const newTicketTypeState = { ...state[ticketType], zones };
  return { ...state, [ticketType]: newTicketTypeState };
};

const setTicketPassengers = (state, payload) => {
  const { ticketType, passengers } = payload;
  const newTicketTypeState = { ...state[ticketType], passengers };
  return { ...state, [ticketType]: newTicketTypeState };
};

const setSeasonalTicketZones = (state, payload) => {
  const { ticketType, seasonalTicketZones } = payload;
  const newState = { ...state[ticketType], seasonalTicketZones };
  return { ...state, [ticketType]: newState };
};
// eslint-disable-next-line
const cardReader = (state = initialState, action) => {
  switch (action.type) {
    case RESET:
      return initialState;
    case ACTIVATE_GREEN_LIGHT:
      return { ...state, greenLightActive: true };
    case ACTIVATE_CARD_LIGHT:
      return { ...state, cardLightActive: true };
    case DEACTIVATE_GREEN_LIGHT:
      return { ...state, greenLightActive: false };
    case DEACTIVATE_CARD_LIGHT:
      return { ...state, cardLightActive: false };
    case SET_CURRENT_ZONE:
      return setCurrentZone(state, action.payload);
    case SET_TICKET_ZONES:
      return setTicketZones(state, action.payload);
    case SET_TICKET_PASSENGERS:
      return setTicketPassengers(state, action.payload);
    case SET_SEASONAL_TICKET_ZONES:
      return setSeasonalTicketZones(state, action.payload);
    default:
      return state;
  }
};

export default cardReader;
